<template>
    <div>

    <v-row>
        <v-col cols="5">
            <SearchTextfield :search="search"/>
        </v-col>

        <v-col class="text-right mb-2">
            <IconButton icon="mdi-refresh" class="mr-2 mb-2" @click="refresh" small />
            <TextButton icon="mdi-link-variant" buttonText="소셜 연동" class="mr-2 mb-2" isPrimary />
        </v-col>
    </v-row>

    <SocialUploadTable 
    :loading="loading"
    :search="search"
    />

    </div>
</template>

<script>
// ui 컴포넌트 import
import IconTextButton from '@/components/ui/button/IconTextButton.vue';
import IconButton from '@/components/ui/button/IconButton.vue';
import TextButton from '@/components/ui/button/TextButton.vue';
import TextButtonBlock from '@/components/ui/button/TextButtonBlock.vue';
import SearchTextfield from '@/components/ui/form/SearchTextfield.vue';
import AppSnackbar from "@/components/ui/snackbar/Snackbar.vue";

// 요소 컴포넌트 import
import SocialUploadTable from "@/components/socialupload/SocialUploadTable.vue";

// api & back import

export default {
    components: {
        // ui 컴포넌트
        IconTextButton,
        IconButton,
        TextButton,
        TextButtonBlock,
        SearchTextfield,
        AppSnackbar,

        // 요소 컴포넌트
        SocialUploadTable,

    },
    data() {
        return {
        
        };
    },
    methods: {
        
        
            
    },
}
</script>